module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "face-page"
  }, [(_vm.faceList.length > 0) ? _c('section', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("YAOPAI为您找到" + _vm._s(_vm.faceList ? _vm.faceList.length : 0) + "张现场照片")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("点击查看大图，长按图片保存至手机相册")]), _vm._v(" "), _vm._l((_vm.faceList), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "face-item",
      attrs: {
        "src": item.Url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.show(index)
        }
      }
    })
  })], 2) : _c('section', {
    staticClass: "tip"
  }, [_c('img', {
    staticClass: "cov",
    attrs: {
      "src": require("../../common/images/Search failure@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v("太低调了，找不到你的身影...")]), _vm._v(" "), _c('p', [_vm._v("上传正面大头最佳，非正面角度人物偏小都会影响精度，照片大小不超过2M")]), _vm._v(" "), _c('upload', {
    ref: "upload",
    attrs: {
      "pId": "face_cons",
      "bId": "face_pics",
      "cb": _vm.uploaded
    }
  }, [_c('div', {
    staticClass: "qiniu",
    slot: "upload"
  }, [_c('img', {
    staticClass: "upload",
    attrs: {
      "width": "50%",
      "src": require("../../common/images/tryagain_icon@2x.png"),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b3bcd02"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/FaceRecogPage.vue
// module id = 517
// module chunks = 1